<script>
    import EditableTextRow from "../EditableTextRow.svelte";
    import Button from "../Button.svelte";
    import { createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher();

    export let data = {},
        classNames = "";
    const state = {
        isDeleting: false,
    };
    import { t } from "../../i18n";

</script>

<div class="row align-items-center">
    {#if state.isDeleting}
        <div class="row">
            <div>{$t('remove_device', {"$replace$": data.name})}</div>
            <div class="row justify-content-flex-end collapse-to-col">
                <Button
                    buttonText="{$t('no_cancel')}"
                    classNames="{'secondary'}"
                    on:click="{() => (state.isDeleting = false)}"
                />
                <Button
                    buttonText="{$t('yes_remove')}"
                    on:click="{() => {
                        state.isDeleting = false;
                        dispatch('message', { action: 'DELETE', data });
                    }}"
                />
            </div>
        </div>
        <div class="row">
            <span>
                {$t('removal_explain')}
            </span>
        </div>
    {:else}
        <EditableTextRow
            content="{data.device_name}"
            extra="{$t('last_used_on', {"$replace$": new Date(data.last).toLocaleDateString("process.env.APP_LOCALE".replace('_', '-'))})}"
            classNames="{classNames}"
            data="{data}"
            on:message
            isDeletable="{true}"
        />
    {/if}
</div>

<style>
    div.row span {
        font-style: italic;
        color: var(--textColorNormal);
    }
    div.row {
        margin: 8px 0px;
    }
</style>
